import { Component, inject, Input,
    ChangeDetectionStrategy
} from '@angular/core';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { FullCalendarWrapper } from '../../models/full-calendar-wrapper.model';
import { ProjectWorkspaceSummary } from "../../models/project-workspace-summary.model";
import { CalendarEvent } from '../../netgen/CalendarEvent';
import { Project } from '../../netgen/Project';
import { ProjectPlanningService } from '../../services/project-planning.service';
import { EditCalendarEventAppointmentComponent } from '../edit-calendar-event-appointment/edit-calendar-event-appointment.component';
import { EditCalendarEventForProjectComponent } from '../edit-calendar-event-for-project/edit-calendar-event-for-project.component';
import { EditProjectComponent } from '../edit-project/edit-project.component';

@Component({
  selector: 'app-project-toolbar',
  standalone: false,
  templateUrl: './project-toolbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './project-toolbar.component.scss',
})
export class ProjectToolbarComponent {

    app = inject(MainAppService);
    service = inject(ProjectPlanningService);

    @Input()
    forProjects = false;

    @Input()
    showSummary = false;

    @Input()
    summary: ProjectWorkspaceSummary;

    @Input()
    calendarWrapper: FullCalendarWrapper;

    @Input()
    project: Project;

    async addProject(): Promise<void> {
        let result = await this.app.dialog.component(EditProjectComponent, this.app.t("ProjectPlanning.createProject"), { width: "95%" }, {
            id: 0
        });  
        if (result.buttonClicked == 'save') {
            await this.app.trackChanges();
        }
    }

    async editProject(): Promise<void> {
        await this.service.editProject(this.project, () => {
            void this.app.trackChanges();
        }, () => {
            void this.app.trackChanges();
        });
    }

    async editProjectRoles(): Promise<void> {
        await this.service.editProjectRoles(this.project, () => {
            void this.app.trackChanges();
        });
    }

    async addTask(): Promise<void> {
        await this.app.dialog.component(EditCalendarEventForProjectComponent, this.app.t("ProjectPlanning.createTask"), null, {
            id: 0,
            item: CalendarEvent.forProject(this.project)
        }); 
        await this.app.trackChanges();
    }

    async addAppointment(): Promise<void> {
        await this.app.dialog.component(EditCalendarEventAppointmentComponent, this.app.t("ProjectPlanning.createAppointment"), null, {
            id: 0,
            item: CalendarEvent.forProject(null)
        }); 
        await this.app.trackChanges();
    }

    jumpToToday(): void {
        this.calendarWrapper.jumpToToday();
    }
    
}
